import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';


export const AccountBillingSkeleton = () => (
    <FormSection headline="Account Billing" info={() => <SkeletonItem width={147} height={28}/>}>
        <Group direction="v">
            <Group direction="v" gap="s">
                <SkeletonItem width={90} height={16}/>
                <SkeletonItem width="100%" height={30}/>
            </Group>
            <Group direction="v" gap="s">
                <SkeletonItem width={66} height={16}/>
                <SkeletonItem width="100%" height={80}/>
            </Group>
            <SkeletonItem width={138} height={32}/>
        </Group>
    </FormSection>
);
